import { render, staticRenderFns } from "./ProductItemCart.vue?vue&type=template&id=aaaae77e&lang=html&"
import script from "./ProductItemCart.vue?vue&type=script&lang=js&"
export * from "./ProductItemCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports